// extracted by mini-css-extract-plugin
export default {"restricted":"AdminContainer_restricted__jZ0MP"};